import configJson from "../config.json"

type ConfigType = typeof configJson;

const config: any = {};
export default config as ConfigType;

const loadConfig = () => {
    return fetch("/config.json", { cache: 'no-store' })
    .then(result => {
        return result.json()
    })
    .then((newconfig) => {
        for(const prop in config) {
            delete config[prop]
        }
        for(const prop in newconfig) {
            config[prop] = newconfig[prop]
        }
        return config;
    });
}

export { loadConfig };
